import axios from 'axios'

export const exportCandidateResume = async () => {
  const response = await axios.get('candidates/resume/export', {
    responseType: 'blob'
  })
  return response
}

/**
 *
 * @param {}
 * @returns
 */
export const getProfileDetails = async () => {
  const response = await axios.get('/users/profile')
  return response
}

// fetch Candidate profile details
export const validateCandidateProfile = async () => {
  const response = await axios.get('candidates/validate-name')
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const updateProfileDetails = async (payload) => {
  const response = await axios.put('users/update-profile', payload)
  return response
}

/**
 *
 * @param {image object} payload
 * @returns
 */

export const uploadProfilePicture = async (payload) => {
  const response = await axios.post(`users/profile-pic`, payload, {
    headers: { 'content-type': 'multipart/form-data' }
  })
  return response
}

/**
 *
 * @param {String} type
 * @returns
 */
export const getIntegrationCredentials = async (type) => {
  const response = await axios.get(`integrations/credentials?type=${type}`)
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const saveIntegrationCredentials = async (payload) => {
  const response = await axios.post(`integrations/credentials`, payload)
  return response
}

/**
 *
 * Fetch User Tour Guide Page Details
 * @returns
 */
export const getUserTourGuide = async () => {
  const response = await axios.get(`user-tour-guide`)
  return response
}

/**
 *
 * Update User Tour Guide Page Details
 * @param {string} pageName
 * @returns
 */
export const updateUserTourGuide = async (pageName) => {
  const response = await axios.put(`user-tour-guide`, null, {
    params: { pageName }
  })
  return response
}

/**
 *
 * Update User Tour Guide Page Details
 * @param {string} pageName
 * @returns
 */
export const updateUserTourSkip = async (pageName) => {
  const response = await axios.put(`user-tour-guide/skip`, null, {
    params: { pageName }
  })
  return response
}
